import { Box, styled } from '@mui/material';

export const CardListRow = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'withBorderBottom',
})<{ withBorderBottom?: boolean }>(({ theme, withBorderBottom = false }) => ({
    padding: theme.spacing(4, 6),
    width: '100%',

    ...(withBorderBottom && {
        borderBottom: `1px solid ${theme.palette.divider}`,
        '&:last-child': {
            borderBottom: 'none',
        },
    }),
}));
